import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import type { DocumentListOptions } from '../../../types/knowledge';
import {
  hasDocumentsNeedingPoll,
  KNOWLEDGE_DOCUMENT_POLL_INTERVAL_MS,
} from '../knowledgePolling';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

type UseKnowledgeDocumentsQueryOptions = {
  databaseId: string | undefined;
  listOptions: DocumentListOptions | undefined;
  enabled: boolean;
};

export function useKnowledgeDocumentsQuery({
  databaseId,
  listOptions,
  enabled,
}: UseKnowledgeDocumentsQueryOptions) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user) && Boolean(databaseId);

  return useQuery({
    queryKey: knowledgeQueryKeys.documents(databaseId ?? '', listOptions),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listDocuments(databaseId!, listOptions),
    refetchInterval: (query) => {
      const documents = query.state.data;
      if (!documents || !hasDocumentsNeedingPoll(documents)) {
        return false;
      }
      return KNOWLEDGE_DOCUMENT_POLL_INTERVAL_MS;
    },
  });
}
